import { defineMessages } from 'react-intl';

export default defineMessages({
  afostoPlatform: {
    id: 'common.afostoPlatform',
    defaultMessage: 'Afosto platform',
    description: 'Common label for afosto platform',
  },
});
